export const MOBILE_STORAGE_KEY = "lift-app-mobile-v1";
export const PHONE_MQ = "(max-width: 719px)";

export type LayoutMode = "phone" | "desktop";

export function parseMobileParam(value: string | null | undefined): "on" | "off" | null {
  if (value == null || value === "") return null;
  const next = value.trim().toLowerCase();
  if (next === "1" || next === "true" || next === "yes" || next === "on") {
    return "on";
  }
  if (next === "0" || next === "false" || next === "no" || next === "off") {
    return "off";
  }
  return null;
}

export function resolveLayout(input: {
  param: string | null | undefined;
  stored: string | null | undefined;
  viewportPhone: boolean;
}): { layout: LayoutMode; sim: boolean; store: "1" | "0" | null } {
  const parsed = parseMobileParam(input.param);
  const store = parsed === "on" ? "1" : parsed === "off" ? "0" : null;
  const forcedOn = parsed === "on" || (parsed === null && input.stored === "1");
  const layout: LayoutMode = input.viewportPhone || forcedOn ? "phone" : "desktop";
  const sim = forcedOn && !input.viewportPhone;
  return { layout, sim, store };
}

export function applyLayoutToDocument(layout: LayoutMode, sim: boolean) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.dataset.layout = layout;
  if (sim) root.dataset.phoneSim = "1";
  else delete root.dataset.phoneSim;
}

export function readStoredMobile(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(MOBILE_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeStoredMobile(value: "1" | "0") {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(MOBILE_STORAGE_KEY, value);
  } catch {
    /* ignore quota / private mode */
  }
}
